import { useEffect, useState } from 'react';
import api from '../../services/api';
import useWrapper from '../useWrapper';

const useCostCenter = props => {
  const query = props?.query || "";
  const { config } = useWrapper();

  const [costCenter, setcostCenter] = useState();
  useEffect(() => {
    (async () => {
      const { data: _cost_center } = await api.get(`cost-center${query}`, config);
      setcostCenter(_cost_center.map(__cost_center => ({
        value: __cost_center.id,
        label: __cost_center.name,
        expensePlan: __cost_center.expensePlan.map(__expense_plan => ({
          value: __expense_plan.id,
          label: __expense_plan.name,
          expenses: __expense_plan.expenses.map(__expense => ({
            value: __expense.id,
            label: __expense.name
          }))
        }))
      })))
    })()
  }, []);

  return costCenter;
}

export default useCostCenter;